import { getApiErrorMessage } from "./getApiErrorMessage";

/**
 * Maps profile / password API `message` strings to i18n keys (EN backend → AR UI).
 */
const PROFILE_API_MESSAGE_TO_KEY = {
  "Profile updated successfully": "profilePage.apiMsgs.profileUpdatedSuccess",
  "Password updated successfully": "profilePage.apiMsgs.passwordUpdatedSuccess",
  "Incorrect current password": "profilePage.apiMsgs.incorrectCurrentPassword",
  "Invalid 2FA token": "profilePage.apiMsgs.invalid2FAToken",
  "Staff accounts cannot update profile details. You can only change your password.":
    "profilePage.apiMsgs.staffCannotUpdateProfile",
  "User not found": "profilePage.apiMsgs.userNotFound",
  "User not found.": "profilePage.apiMsgs.userNotFound",
  "Server error": "profilePage.apiMsgs.serverError",
  "This email is already registered to another account":
    "profilePage.apiMsgs.emailAlreadyRegistered",
  "This phone number is already registered to another account":
    "profilePage.apiMsgs.phoneAlreadyRegistered",
  "Email is required": "profilePage.validation.emailRequired",
  "Please enter a valid email address": "profilePage.validation.invalidEmail",
  "Please include a valid email": "profilePage.validation.invalidEmail",
  "Phone number is required": "profilePage.validation.phoneRequired",
  "Please enter a valid KSA phone number (e.g., +966501234567, 966501234567, 0501234567, or 501234567)":
    "profilePage.validation.invalidKsaPhone",
};

/**
 * @param {string} message
 * @returns {string|null}
 */
function matchDynamicProfileMessage(message) {
  const s = String(message || "").trim();
  if (/^This email is already in use/i.test(s)) {
    return "profilePage.apiMsgs.emailAlreadyInUse";
  }
  if (/^This phone is already in use/i.test(s)) {
    return "profilePage.apiMsgs.phoneAlreadyInUse";
  }
  return null;
}

/**
 * @param {unknown} message
 * @param {import('i18next').TFunction} t
 * @returns {string}
 */
export function translateProfileApiMessage(message, t) {
  if (message == null || message === "") return "";
  const s = String(message).trim();
  const mapped = PROFILE_API_MESSAGE_TO_KEY[s] || matchDynamicProfileMessage(s);
  if (mapped) return t(mapped);
  return t(s, { defaultValue: s });
}

/**
 * @param {unknown} err
 * @param {import('i18next').TFunction} t
 * @param {string} fallbackKey
 * @returns {string}
 */
export function resolveProfileApiError(err, t, fallbackKey) {
  const raw = getApiErrorMessage(err);
  if (raw) return translateProfileApiMessage(raw, t);
  return t(fallbackKey);
}
